import { render, staticRenderFns } from "./Acoes.vue?vue&type=template&id=68071943&scoped=true&"
import script from "./Acoes.vue?vue&type=script&lang=js&"
export * from "./Acoes.vue?vue&type=script&lang=js&"
import style0 from "./Acoes.vue?vue&type=style&index=0&id=68071943&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68071943",
  null
  
)

export default component.exports